import type {Dispatch, SetStateAction} from 'react'
import type React from 'react'
import {useState} from 'react'

type InputHandlers = {
  onKeyDown: (e: React.KeyboardEvent) => void
  onBlur: () => void
}

export function useInlineInput(): [boolean, Dispatch<SetStateAction<boolean>>, InputHandlers] {
  const [isEditing, setIsEditing] = useState(false)

  return [
    isEditing,
    setIsEditing,
    {
      onKeyDown: e => {
        switch (e.key) {
          case 'Enter':
          case 'Escape':
            setIsEditing(false)
            break
          default:
        }
      },
      onBlur: () => setIsEditing(false),
    },
  ]
}
